import "./cta-landing-card.scss"


interface Props {
    className?: string
}

const CtaLandingCard = (props: Props) => {


    return (
        <div className="cta-landing-card">

            <div className="cta-card">
                <h3 className="cta-header">Take your marketing to the next level</h3>
                <div  className="mt-5 button-wrapper">
                    <button>Request for Demo</button>
                    <button className="secondary">Chat with us</button>
                </div>

            </div>
        </div>
    )

}
export default CtaLandingCard
